const map = {
	"./Buffalo.jpg": 2870,
	"./anil.jpeg": 9712,
	"./arun.jpeg": 1474,
	"./bgdairy.jpg": 5203,
	"./bgdairyt.jpg": 8919,
	"./buttermilk.png": 4322,
	"./cowBg": 1847,
	"./cowmilk.png": 3149,
	"./cownewBg": 3805,
	"./curd.png": 1467,
	"./dairybg1.jpg": 3500,
	"./dairybg2.jpg": 5483,
	"./dairybg3.jpg": 7438,
	"./dairybg4.jpg": 9909,
	"./dairybg5.jpg": 2040,
	"./ghee.png": 6226,
	"./krushilogo.png": 7930,
	"./krushiratnaLogo.jpg": 9620,
	"./krushnaroa.jpeg": 14,
	"./lassi.png": 4841,
	"./paneer.png": 2286,
	"./plant.jpg": 6702,
	"./taza milk.png": 1062
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4541;